export default __webpack_public_path__ + "static/media/figma_logo.e935b5c2.svg";